import React from 'react'
import Header from '../components/Header'
import Main from '../components/Main'
import Loading from '../components/Main'
import RoutesView from '../components/RoutesView'
import MetaData from '../components/MetaData'
import { settings } from '../conf'
import { useGuide } from "../api"
import { ROUTES_LIST, ROUTES_DESCRIPTION } from '../trans'


const Home = () => {
  const guide = useGuide()

  if (!guide) return (
    <>
      <Header></Header>
      <Main>
        <Loading/>
      </Main>
    </>
  )

  const title = ROUTES_LIST
  const description = ROUTES_DESCRIPTION({route_title: guide.title})
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name":  `${guide.title} - ${guide.subtitle}`,
    "applicationCategory": "TravelApplication",
    "offers": {
      "@type": "Offer",
      "price": "0"
    },
    "author": {
      "@type": "Organization",
      "name": "Forwalk.org",
      "url": "https://forwalk.org",
      "logo": settings.STATIC_URL + 'images/logo_publisher.svg'
    },
    "publisher": {
      "@type": "Organization",
      "name": "Forwalk.org",
      "url": "https://forwalk.org",
      "logo": settings.STATIC_URL + 'images/logo_publisher.svg'
    }
  }

  return (
    <>
      <MetaData title={title} 
                description={description} 
                jsonLd={jsonLd} />
      <Header></Header>
      <Main>
        <RoutesView/>
      </Main>
    </>
  )
}

export default Home
